import { Helmet } from "react-helmet";
import styles from "./LiveSupport.module.scss";
import { LiveSupportService } from "../../services/live_support.service";
import { useEffect, useState } from "react";
import Spinner from "../../components/shared/Spinner/Spinner";
import { LiveSupportTypes } from "../../interfaces/admin.interface";
import { useNavigate } from "react-router-dom";

const LiveSupport = () => {
  const [userList, setUserList] = useState<LiveSupportTypes[]>([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    LiveSupportService.getAllUserList()
      .then((res) => {
        setUserList(res.data.chats.data);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);
  const navigation = useNavigate();
  return (
    <div id="pages">
      <Helmet>
        <title>Orhan Door | Canlı Dəstək</title>
      </Helmet>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className="page_head">
            <h3 className="page_title">Gələn mesajlar</h3>
          </div>
          <div className="pages_components">
            <div className={styles.table}>
              <div className={styles.header}>
                <div>№</div>
                <div>İstifadəçi</div>
                <div>Son yazma tarixi</div>
              </div>
              {userList.map((item, idx) => {
                return (
                  <div
                    key={idx}
                    className={`${styles.row} ${
                      item.is_read === 0 ? styles.unread_row : ""
                    }`}
                    onClick={() => {
                      navigation(`messaging/${item.chat_id}`);
                      setUserList((prev) =>
                        prev.map((chat) =>
                          chat.chat_id === item.chat_id
                            ? { ...chat, is_read: 1 }
                            : chat
                        )
                      );
                    }}
                  >
                    <div>{idx + 1}</div>
                    <div>{item.user_name}</div>
                    <div>{item.last_message_date || "-"}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LiveSupport;
